import React from "react"
import { getIdWithoutSpecialSymbols } from "@repo/utils"
import { TYPES } from "../../../lib"
import dynamicWithLoader from "../common/DynamicWithLoader"

const QuoteText = dynamicWithLoader(() => import("./QuoteText"))
const TextCentered = dynamicWithLoader(() => import("./TextCentered"))
const HeaderDescriptionTwoColumns = dynamicWithLoader(() => import("./HeaderDescriptionTwoColumns"))
const BigHeaderDescriptionTwoColumns = dynamicWithLoader(() => import("./BigHeaderDescriptionTwoColumns"))
const HeaderDescriptionHalfWidth = dynamicWithLoader(() => import("./HeaderDescriptionHalfWidth"))
const TextWithBreaksWithoutItalic = dynamicWithLoader(() => import("./TextWithBreaksWithoutItalic"))
const BigTypography = dynamicWithLoader(() => import("../BigTypography"))
const TextMedium = dynamicWithLoader(() => import("./TextMedium"))

function TextModules({ data, locale, isServicePage }) {
	const textModulesData = data?.chooseTextModuleVariants || []
	const textModuleId = getIdWithoutSpecialSymbols(data.id)
	if (!Array.isArray(textModulesData)) return null
	return textModulesData.map((item, index) => {
		const itemTypename = item?.__typename || null
		switch (itemTypename) {
			case TYPES.QUOTE_BLOCK:
				return <QuoteText key={item.id || index} data={item} locale={locale} textModuleId={textModuleId} />
			case TYPES.TEXT_CENTERED_BLOCK:
				return <TextCentered key={item.id || index} data={item} locale={locale} textModuleId={textModuleId} />
			case TYPES.HEADER_DESCRIPTION_TWO_COLUMNS_BLOCK:
				return <HeaderDescriptionTwoColumns key={item.id || index} data={item} locale={locale} textModuleId={textModuleId} />
			case TYPES.BIG_HEADER_DESCRIPTION_TWO_COLUMNS_BLOCK:
				return (
					<BigHeaderDescriptionTwoColumns
						key={item.id || index}
						data={item}
						locale={locale}
						textModuleId={textModuleId}
						isServicePage={isServicePage}
					/>
				)
			case TYPES.HEADER_DESCRIPTION_HALF_WIDTH_BLOCK:
				return <HeaderDescriptionHalfWidth key={item.id || index} data={item} locale={locale} textModuleId={textModuleId} />
			case TYPES.TEXT_BREAK:
				return <TextWithBreaksWithoutItalic key={item.id || index} data={item} locale={locale} textModuleId={textModuleId} />
			case TYPES.TYPOGRAPHY_BIG:
				return <BigTypography key={item.id || index} data={item} textModuleId={textModuleId} />
			case TYPES.TYPOGRAPHY_MEDIUM_TEXT:
				return <TextMedium key={item.id || index} data={item} textModuleId={textModuleId} />
			default:
				return <p key={item.id}>Brak obsługi dla {itemTypename}</p>
		}
	})
}

export default TextModules
